<template>
    <div class="footer">
        <div class="wrapper">
            <ul>
                <li class="footer-li1">仙桃创源计算机科技中等职业学校</li>
                <li>
                    <span id="busuanzi_container_site_pv"><br>
                        本站总访问量<span id="busuanzi_value_site_pv" style="margin-left:0.1rem"></span>次
                        本站访客数<span id="busuanzi_value_site_uv"></span>人次
                    </span>
                </li>
                <li>
                    <span>电话:0728-3223248</span>
                    <span>手机:15826886098</span>
                </li>
                <li>
                    <span>Q:3030519647</span>
                    <span>43815119</span>
                    <span>724341068</span>
                </li>
                <li>地址:仙桃汉江大桥东侧50米</li>
                <li>网站开发者：软件开发班 吴鼎</li>
                <li><a href="#">鄂ICP备06000945号-1</a></li>
                <li><a href="#">鄂公网安备 429004200433号</a></li>
            </ul>
        </div>
        <div class="erweima">
            <img src="/image/el-ma.png" alt="" />
        </div>
    </div>
</template>
<script>
export default {
    name: 'bottom'
}
</script>
<style></style>